module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_html.js
// module id = ../../../../core-js/library/modules/_html.js
// module chunks = 7